import cx from 'clsx';
import Image from 'next/image';

import { joinSgcmMedia } from '@/utils/url/join/public';

import { ICON_SIZE_IN_PIXEL } from '../../../constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Row: Component = ({
  item,
  hasDesc,
  onClickDesc,
}) => (
  <div className={styles.containerRow}>
    <div className={cx(
      styles.containerCell,
      styles.containerInfoTitle,
    )}>
      <div className={styles.textTitle}>
        {item.title}
      </div>
      {hasDesc && onClickDesc && (
        <button
          className={styles.iconExclamationMark}
          onClick={onClickDesc}>
          <Image
            alt="icon exclamation mark"
            height={ICON_SIZE_IN_PIXEL}
            src={`${joinSgcmMedia('/public/new-cars/icon/information.svg')}`}
            width={ICON_SIZE_IN_PIXEL} />
        </button>
      )}
    </div>
    <div className={cx(styles.containerCell, styles.containerInfoValue)}>
      {item.value}
    </div>
  </div>
);
